import { useTranslation } from 'react-i18next';
import { ModalWrapper } from 'src/components/ModalWrapper';
import { Button } from 'src/components/Buttons/Button';
import { useModalContext } from 'src/hooks/useModalContext';
import { LastTransactions } from 'src/components/TransactionHistory/components/LastTransactions';

export const LatestDepositsModal = () => {
  const { closeModal, modalProps } = useModalContext<{ merchantId: string | undefined }>();
  const { t } = useTranslation();

  return (
    <ModalWrapper containerClassName="max-w-[1000px] px-5">
      <p className="text-xl font-bold text-ldp_title text-center pt-8 pb-5">
        {t('transactionsTable.transactionsHistory')}
      </p>
      <LastTransactions merchantId={modalProps?.merchantId} transactionsType="deposit" />
      <div className="pt-1 768:pt-5 pb-8 w-full flex items-center justify-center">
        <Button mode="button-primary" className="self-center" onClick={closeModal}>
          {t('gameNotification.close')}
        </Button>
      </div>
    </ModalWrapper>
  );
};
